import { ReactNode } from 'react';

import { COLORS } from '~/styles/colors';

import { StyledTitleH1, StyledTitleH2, StyledTitleH3, StyledTitleH4, StyledTitleSubheader } from './styled';

export const TITLE_TYPE = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  subheader: 'subheader',
} as const;

const mapper = {
  [TITLE_TYPE.h1]: StyledTitleH1,
  [TITLE_TYPE.h2]: StyledTitleH2,
  [TITLE_TYPE.h3]: StyledTitleH3,
  [TITLE_TYPE.h4]: StyledTitleH4,
  [TITLE_TYPE.subheader]: StyledTitleSubheader,
};

type TitleProps = {
  type?: keyof typeof TITLE_TYPE;
  children: ReactNode;
  color?: string;
  center?: boolean;
  pb?: number;
  pt?: number;
  pl?: number;
  pr?: number;
  mt?: number;
  mb?: number;
  ml?: number;
  mr?: number;
  className?: string;
};

export const Title = ({
  type = TITLE_TYPE.h1,
  children,
  color = COLORS.textMain,
  center,
  pb,
  pt,
  pl,
  pr,
  mt,
  mb,
  ml,
  mr,
  className,
}: TitleProps) => {
  const Component = mapper[type];
  const textAlign = center ? 'center' : 'left';

  return (
    <Component
      $color={color}
      $textAlign={textAlign}
      className={className}
      $pb={pb}
      $pt={pt}
      $pl={pl}
      $pr={pr}
      $mt={mt}
      $mb={mb}
      $ml={ml}
      $mr={mr}
    >
      {children}
    </Component>
  );
};
